export default {
  data() {
    return {
      emitente: {},
    };
  },
  methods: {
    async getDadosEmitente() {
      const { data } = await this.$http.post("/empresa");
      return data;
    },
    async getDadosEmissor() {
      const { data } = await this.$http.post("/empresa/dados-emissor");
      return data;
    },
    formatCpfCnpj(valor) {
      if (valor === null || valor === undefined || valor === "") {
        return "";
      }

      const value = String(valor);
      const cnpj = value
        .trim()
        .replace(/[./-]/g, "")
        .toUpperCase();

      if (cnpj.length === 14 || /[A-Z]/.test(cnpj)) {
        return cnpj
          .slice(0, 14)
          .replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})$/, "$1.$2.$3/$4-$5");
      }

      const cpf = value.replace(/\D/g, "");

      if (cpf.length <= 11) {
        // eslint-disable-next-line
        return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, `\$1.\$2.\$3\-\$4`);
      }

      // eslint-disable-next-line
      return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "\$1.\$2.\$3\/\$4\-\$5");
    },
  },
};
